<div class="footer" aria-label="footer">
  <div class="container">
    <div class="copyright-text">
      <span class="text-year">{{
        'footer.copyright_text_year' | translate
      }}</span>
      <span class="text-content">{{
        'footer.copyright_text_content'
          | translate: footerCopyrightTextContentParams()
      }}</span>
    </div>
    <a class="footer-logo-container" [routerLink]="['/']">
      <img class="footer-logo" [src]="logoImageUrl()" />
    </a>
  </div>
</div>
